var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Abstract from './abstract';
var Select2 = /** @class */ (function (_super) {
    __extends(Select2, _super);
    function Select2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Select2.prototype.getEditable = function () {
        var editable = this.Editables.get('select2');
        return editable ? editable : false;
    };
    Select2.prototype.map = function () {
        this.args.select2 = {
            width: 320,
            theme: 'acs2',
            data: AdminColumns.Editing.Helper.formatOptionsSelect2(this.column.editable.options),
            escapeMarkup: function (text) { return jQuery('<div>' + text + '</div>').text(); }
        };
        if (this.column.editable.ajax_populate) {
            this.args.select2.ajax = this.mapAjax();
            this.args.ajax = true;
        }
        if (this.column.editable.multiple) {
            this.args.select2.multiple = true;
            this.args.select2.closeOnSelect = false;
        }
        if (this.column.editable.tags) {
            this.args.select2.tags = true;
        }
    };
    Select2.prototype.mapAjax = function () {
        var column_name = this.column.name;
        return {
            url: ajaxurl,
            dataType: 'json',
            delay: 500,
            data: function (params) {
                var data = {
                    action: 'acp_editing_single_request',
                    method: 'get_select_values',
                    layout: AC.layout,
                    searchterm: params.term,
                    page: params.page,
                    column: column_name,
                    list_screen: AC.list_screen,
                    _ajax_nonce: AC.ajax_nonce
                };
                if (this[0].dataset.hasOwnProperty('objectId')) {
                    data.item_id = this[0].dataset.objectId;
                }
                return data;
            },
            processResults: function (response) {
                if (response.success) {
                    return response.data;
                }
                return { results: [] };
            }
        };
    };
    return Select2;
}(Abstract));
export default Select2;
